import { Check, FileText, Loader2, TriangleAlert } from "lucide-react";
import type { RevisionSaveState } from "./draftCanvasTypes";

export const SaveStatusPill = ({
  state,
  error,
}: {
  state?: RevisionSaveState;
  error?: string | null;
}) => {
  if (!state || state === "idle") return null;
  if (state === "saving") {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
        <Loader2 className="h-3 w-3 animate-spin" /> Saving…
      </span>
    );
  }
  if (state === "saved") {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
        <Check className="h-3 w-3" /> Saved
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 text-xs text-destructive">
      <TriangleAlert className="h-3 w-3" /> {error || "Save failed"}
    </span>
  );
};

export const EmptyState = ({ message, hint }: { message: string; hint: string }) => (
  <div className="flex h-full min-h-[280px] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-border/60 bg-muted/20 p-8 text-center">
    <FileText className="h-8 w-8 text-muted-foreground" />
    <p className="text-sm font-medium">{message}</p>
    <p className="max-w-md text-xs text-muted-foreground">{hint}</p>
  </div>
);
